import { axios } from '@Root/API'

export const getById = userId => {
	return axios.get(`users/${userId}`)
}
